import React from "react";
import { PropsWithChildren } from "react";

export type ChildWrapperProps = PropsWithChildren<{
  Wrapper: ({ children }) => React.ComponentElement<any, any>;
}>;

export const ChildWrapper = ({ Wrapper, children }: ChildWrapperProps) => {
  const childrenList = React.Children.toArray(children);

  return (
    <>
      {childrenList.map((child, index) => {
        if (child && React.isValidElement(child)) {
          return <Wrapper key={child.key || index}>{child}</Wrapper>;
        }

        return null;
      })}
    </>
  );
};
